<template>
  <nav aria-label="Breadcrumb">
    <ol role="list" class="mb-0 flex">
      <li v-for="(crumb, index) in props.breadcrumbs" :key="`link-${index}`" class="max-w-40 relative flex pl-3 first:pl-0">
        <RouterLink
          v-if="crumb.route"
          class="truncate text-sm py-3 pr-8 text-grey-500 leading-none font-medium transition-colors duration-200 ease-in-out hover:text-emerald-600 focus:text-emerald-600"
          :to="crumb.route">
          {{ crumb.label }}
        </RouterLink>
        <a
          v-else
          href="#"
          class="truncate text-sm py-3 text-grey-500 leading-none font-medium cursor-default hover:text-grey-500 focus:text-grey-500"
          aria-current="page">
          {{ crumb.label }}
        </a>
        <div v-if="crumb.route" class="block absolute top-0 right-0 h-full w-5" aria-hidden="true">
          <svg class="h-full w-full text-grey-200" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
          </svg>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script setup>
const props = defineProps({ breadcrumbs: { type: [Object], default: null } });
</script>
